const registrationForm = [
  {
    question: '與住院病人的關係',
    options: [
      '家人',
      '朋友',
      '雇主',
    ],
    response: '',
  },
  {
    question: '最近14日內旅遊史',
    options: [
      '有',
      '無',
    ],
    response: '',
  },
  {
    question: '您的職業別為何?',
    options: [
      '醫院工作者(如醫事/非醫事人員)',
      '交通運輸業(如計程車、客運司機)',
      '旅遊業(如導遊),旅館業(如房務、接待人員)',
      '航空服務業(如空服機組員)',
      '其他',
      '無',
    ],
    response: '',
  },
  {
    question: '您近期接觸及出入場所',
    options: [
      '曾至醫院、診所就醫 曾接觸到國外旅遊且有發燒或呼吸道症狀親友',
      '曾出入機場、觀光景點及其他頻繁接觸外國人場所',
      '曾參加50人以上大型活動',
      '無',
    ],
    response: '',
  },
  {
    question: '您最近一個月群聚史',
    options: [
      '同住家人正在居家隔離,同住家人正在居家檢疫',
      '同住家人正在自主健康管理',
      '家人也有發燒或呼吸道症狀',
      '朋友也有發燒或呼吸道症狀',
      '同事也有發燒或呼吸道症狀',
      '無',
    ],
    response: '',
  },
  {
    question: '您最近14天內是否有以下症狀',
    options: [
      '發燒,肌肉痠痛,極度疲倦感,腹瀉',
      '近期使用退燒藥或感冒藥',
      '咳嗽,頭痛,流鼻水,鼻塞,喉嚨痛',
      '無',
    ],
    response: '',
  },
  {
    question: '預約時間',
    options: [
      '當天',
      '隔天',
    ],
    response: '',
  },
  {
    question: '探嬰預約時間，訪客時間為星期一至星期六上午11:00-11:45，每位寶寶探視時間為15分鐘，限1人',
    options: [
      '11:00-11:15',
      '11:15-11:30',
      '11:30-11:45',
    ],
    response: '',
  },
  {
    question: '本次是否要探視住院病人?',
    options: [
      '是',
      '否',
    ],
    response: '',
  },
];

export default registrationForm;
//! use npm vue-excel-xlsx 匯出
